import React from "react";
import ForgotPasswordSection from "../sections/ForgotPasswordSection/Content";
const forgotPasswordPage = () => {
  return <ForgotPasswordSection />;
};

export default forgotPasswordPage;
